import moment from 'moment'
import { $t } from '../i18n'
import { HTTP_HYPER_ESPACE_BACKEND } from "@/services/http-common";

export async function getExports () {

  return HTTP_HYPER_ESPACE_BACKEND
    .get('/exports/')
    .then(response => {
      return {
        total: response.data.list.length,
        list: response.data.list
      }
    })
    .catch(error => {
      return error
    })
}

export async function downloadExports (files) {
  if (files.length === 0) { return false }

  const params = {
    responseType: 'blob',
    params: { files }
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .get('/download-export', params)
    .then(response => {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([response.data]))
      document.body.appendChild(link)

      if (files.length === 1) {
        link.setAttribute('download', files[0]) // or any other extension
      } else {
        link.setAttribute('download', 'exports_' + moment().format('DD_MM_YYYY_HH_mm_ss') + '.zip')
      }

      link.click()
      link.remove()
    }, files)
    .catch(error => {
      return { type: 'error', message: error }
    })
}

export async function removeExports (files) {
  if (files.length === 0) { return false }

  const params = {
    params: { files }
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .delete('/remove-export', params)
    .then(response => {
      if (files.length === 1) {
        return { type: 'success', message: $t('exports.removeSuccess') }
      } else {
        return { type: 'success', message: $t('exports.multipleRemoveSuccess') }
      }
    })
    .catch(error => {
      // return {type: "error", message: $t("error.found")};
    })
}
